import { makeStyles } from "@mui/styles";
import { DataGridPro } from "@mui/x-data-grid-pro";
import React, { useState } from "react";
import { DECLARATION_PAGE_TYPE } from "../../util/constants";
import { getColumns } from "../../util/declarations/declarationUtils";
import CustomErrorTableOverlay from "../CustomErrorTableOverlay";
import customLoadingTableOverlay from "../CustomLoadingTableOverlay";
import CustomNoRowsTableOverlay from "../CustomNoRowsTableOverlay";

const useStyles = makeStyles((theme) => ({
  declarationsTable: () => ({
    "& div": {
      "& .MuiDataGrid-footerContainer": {
        display: "none",
      },
    },
    borderRadius: "0px",
  }),
  evenRow: {
    backgroundColor: theme.palette.secondary.swaGray1,
  },
  tempChip: {
    marginLeft: "5px",
  },
}));

const DeclarationsTable = (props) => {
  const classes = useStyles();
  const [sortModel, setSortModel] = useState([
    {
      field: "name",
      sort: "asc",
    },
  ]);

  return (
    <div style={{ width: "100%", height: "inherit", paddingLeft: "4.2vw", paddingRight: "3.76vw" }}>
      <DataGridPro
        className={classes.declarationsTable}
        rows={props.declarations}
        columns={getColumns(props)}
        sortModel={sortModel}
        onSortModelChange={(event) => setSortModel(event)}
        sortingOrder={["asc", "desc"]}
        rowKeyGetter={(row) => row.eid}
        getRowId={(row) => row.eid}
        getRowClassName={(row) => {
          return `${row.indexRelativeToCurrentPage % 2 === 0 ? classes.evenRow : ""}`;
        }}
        disableColumnMenu={true}
        rowHeight={50}
        components={{
          LoadingOverlay: customLoadingTableOverlay,
          NoRowsOverlay: CustomNoRowsTableOverlay,
          ErrorOverlay: CustomErrorTableOverlay,
        }}
        componentsProps={{
          noRowsOverlay: {
            pageType: DECLARATION_PAGE_TYPE,
          },
          errorOverlay: {
            errorMessage: props.errorObject.message,
            errorCode: props.errorObject.code,
          },
        }}
        loading={props.isLoading}
        error={props.isError}
      />
    </div>
  );
};

export default DeclarationsTable;
